<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100">
    <div fxLayout="column" fxLayoutAlign="center center">
      <Teranet-PageTitle [PageTitle]="'Reset Password'"></Teranet-PageTitle>
      <form [formGroup]="resetPasswordForm" #userFormRef="ngForm" (ngSubmit)="OnSubmit()">
        <div [hidden]="!isTokenValid" class="form-group-flex-column">
          <mat-label class="required-field-after">New Password</mat-label>
          <mat-form-field class="mat-form-field-lg" appearance="outline">
            <input matInput
                   data-lpignore="true"
                   [type]="'password'"
                   formControlName="password"
                   [(ngModel)]="resetPasswordModel.password"
                   autocomplete="new-password"
                   required />
            <mat-error *ngIf="resetPasswordForm.get('password').hasError('required')">
              Required
            </mat-error>
            <mat-error *ngIf="resetPasswordForm.get('password').hasError('minlength')">
              Password length must be at least
              {{ resetPasswordForm.get('password').errors.minlength.requiredLength }}
            </mat-error>
          </mat-form-field>
        </div>
        <div [hidden]="!isTokenValid" class="form-group-flex-column">
          <mat-label class="required-field-after">Confirm New Password</mat-label>
          <mat-form-field class="mat-form-field-lg" appearance="outline">
            <input matInput
                   data-lpignore="true"
                   [type]="'password'"
                   formControlName="confirmpassword"
                   [(ngModel)]="resetPasswordModel.confirmPassword"
                   autocomplete="off"
                   required />
            <mat-error *ngIf="resetPasswordForm.get('confirmpassword').hasError('required')">
              Required
            </mat-error>
            <mat-error *ngIf="resetPasswordForm.get('confirmpassword').hasError('mustMatch')">
              The Password and Confirm Password fields do not match
            </mat-error>
          </mat-form-field>
        </div>
        <div [hidden]="!isTokenValid" fxLayout="row wrap" fxLayoutAlign="end">
          <button mat-raised-button class="plain-button" type="button" (click)="onCancel()">Cancel</button>
          <button mat-raised-button class="theme-button" type="submit" [disabled]="!resetPasswordForm.valid">Change Password</button>
        </div>
      </form>
      <div [hidden]="!isTokenValid">
        <div *ngIf="(isError != undefined) && isError" class="alert alert-danger" role="alert">
          <div>1 errors were found.</div>
          <div *ngIf="isPasswordWeak"><b>Password</b> must meet the following minimum password strength requirements:</div>
          <ul *ngFor="let item of errorMessage">
            <li>{{ item }}</li>
          </ul>
        </div>
      </div>
      <div [hidden]="isTokenValid">
        <div class="alert alert-success" role="alert">
          The link you followed has expired.
        </div>
        <div fxLayout="row wrap" fxLayoutAlign="end">
          <button mat-raised-button class="theme-button" type="button" (click)="onOk()">Ok</button>
        </div>
      </div>
    </div>
  </div>
</div>
